import { nodeComponentRegistry } from '../../../r3f/NodeComponentRegistry';
import { Decal } from './Component';
nodeComponentRegistry.register({ typeName: 'Decal', Component: Decal, editorIcon: { icon: 'GizmoDecal' } });
//# sourceMappingURL=index.r3f.js.map